import React from "react";
import { Box } from "@mui/material";
import { CompilationTrackSearchResult } from "../../types/CompilationTrackSearchResult";
import { format, trackDuration } from "../../components/text-helper/text-helper";
import { Link } from "react-router-dom";
import HighlightedText from "./HighlightedText";
import "./Search.scss";

interface CompilationTrackSearchReulstProps {
    index: number;
    searchText: string;
    trackMessage: CompilationTrackSearchResult;
}

const CompilationTrackSearchComponent = (props: CompilationTrackSearchReulstProps) => {    
    return (
        <Box component={Link}
            className="search-result"
            key={`$track-${props.index}`}
            to={`/compilations/${props.trackMessage.compilation.directory}/albums/${props.trackMessage.compilation.year} - ${props.trackMessage.compilation.title}`}
        >
            <HighlightedText searchText={props.searchText} term={props.trackMessage.track.name} />
            #{String(props.trackMessage.track.number).padStart(2, '0')} ({trackDuration(props.trackMessage.track.duration)}) on
            <br />{props.trackMessage.compilation.title} ({props.trackMessage.compilation.year})
            <br />by {format(props.trackMessage.track.artistName)}
            <br />in {format(props.trackMessage.compilation.directory)}
        </Box>
    );
}

export default CompilationTrackSearchComponent;